// @ts-check
import { createEnv } from "@t3-oss/env-nextjs"
import * as z from "zod"

export const env = createEnv({
  server: {
    BETTER_AUTH_SECRET: z.string().min(1),
    BETTER_AUTH_URL: z.string().min(1),
    BETTER_AUTH_DB_PROVIDER: z
      .enum(["sqlite", "pg", "mysql"])
      .default("sqlite"),
    DATABASE_CONNECTION_STRING: z.string().optional(),
    DATABASE_HOST: z.string().optional(),
    DATABASE_USER: z.string().optional(),
    DATABASE_PASSWORD: z.string().optional(),
    DATABASE_NAME: z.string().optional(),
    SQLITE_FILE_PATH: z.string().optional().default("./sqlite.db"),
  },
  client: {
    NEXT_PUBLIC_BASE_URL: z.string().min(1),
    NEXT_PUBLIC_GO_API_URL: z.string().min(1),
  },
  runtimeEnv: {
    BETTER_AUTH_SECRET: process.env.BETTER_AUTH_SECRET,
    BETTER_AUTH_URL: process.env.BETTER_AUTH_URL,
    BETTER_AUTH_DB_PROVIDER: process.env.BETTER_AUTH_DB_PROVIDER,
    DATABASE_CONNECTION_STRING: process.env.DATABASE_CONNECTION_STRING,
    DATABASE_HOST: process.env.DATABASE_HOST,
    DATABASE_USER: process.env.DATABASE_USER,
    DATABASE_PASSWORD: process.env.DATABASE_PASSWORD,
    DATABASE_NAME: process.env.DATABASE_NAME,
    SQLITE_FILE_PATH: process.env.SQLITE_FILE_PATH,
    NEXT_PUBLIC_BASE_URL: process.env.NEXT_PUBLIC_BASE_URL,
    NEXT_PUBLIC_GO_API_URL: process.env.NEXT_PUBLIC_GO_API_URL,
  },
})
